import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getStyles, translate } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';

import Icon from '../Icon/Icon';

import localStyles from './Notifications.scss';
const styles = getStyles(localStyles);

class Notifications extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { timeouts: {} };
    }

    componentDidMount() {
        this.setTimeouts();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.notificationsData.length !== this.props.notificationsData.length) {
            this.setTimeouts();
        }

        // CONDITION PROPS
        if (prevProps.verificationLoading !== this.props.verificationLoading && prevProps.verificationLoading && !this.props.verificationLoading) {
            if (this.props.verificationSuccess) {
                // Don't show success notification
            } else if (this.props.verificationError) {
                this.props.addNotification({ message: `${translate('notifications.condition.verificationError', this.props.language)} ${this.props.verificationError}`, type: 'error' });
            }
        }
        if (prevProps.confirmEmailLoading !== this.props.confirmEmailLoading && prevProps.confirmEmailLoading && !this.props.confirmEmailLoading) {
            if (this.props.confirmEmailSuccess) {
                // Don't show success notification
            } else if (this.props.confirmEmailError) {
                this.props.addNotification({ message: `${translate('notifications.condition.confirmEmailError', this.props.language)} ${this.props.confirmEmailError}`, type: 'error' });
            }
        }
        if (prevProps.userLogoutLoading !== this.props.userLogoutLoading && prevProps.userLogoutLoading && !this.props.userLogoutLoading) {
            if (this.props.userLogoutSuccess) {
                this.props.addNotification({ message: translate('notifications.condition.userLogoutSuccess', this.props.language), type: 'success' });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else if (this.props.userLogoutError) {
                this.props.addNotification({ message: `${translate('notifications.condition.userLogoutError', this.props.language)} ${this.props.userLogoutError}`, type: 'error' });
            }
        }
        if (prevProps.userPreferenceLoading !== this.props.userPreferenceLoading && prevProps.userPreferenceLoading && !this.props.userPreferenceLoading) {
            if (this.props.userPreferenceSuccess) {
                // Don't show success notification
            } else if (this.props.userPreferenceError) {
                this.props.addNotification({ message: `${translate('notifications.condition.userPreferenceError', this.props.language)} ${this.props.userPreferenceError}`, type: 'error' });
            }
        }
        if (prevProps.userUpdateLoading !== this.props.userUpdateLoading && prevProps.userUpdateLoading && !this.props.userUpdateLoading) {
            if (this.props.userUpdateSuccess) {
                this.props.addNotification({ message: translate('notifications.condition.userUpdateSuccess', this.props.language), type: 'success' });
            } else if (this.props.userUpdateError) {
                this.props.addNotification({ message: `${translate('notifications.condition.userUpdateError', this.props.language)} ${this.props.userUpdateError}`, type: 'error' });
            }
        }
        if (prevProps.passwordChangeLoading !== this.props.passwordChangeLoading && prevProps.passwordChangeLoading && !this.props.passwordChangeLoading) {
            if (this.props.passwordChangeSuccess) {
                this.setState({ isPasswordModalOpen: false });
                this.props.addNotification({ message: translate('notifications.condition.passwordChangeSuccess', this.props.language), type: 'success' });
            } else if (this.props.passwordChangeError) {
                // Don't show error notification
            }
        }
        if (prevProps.removeCartVoucherLoading !== this.props.removeCartVoucherLoading && prevProps.removeCartVoucherLoading && !this.props.removeCartVoucherLoading) {
            if (this.props.removeCartVoucherSuccess) {
                this.props.addNotification({ message: translate('notifications.condition.removeCartVoucherSuccess', this.props.language), type: 'success' });
            } else if (this.props.removeCartVoucherError) {
                this.props.addNotification({ message: `${translate('notifications.condition.removeCartVoucherError', this.props.language)} ${this.props.removeCartVoucherError}`, type: 'error' });
            }
        }
        if (prevProps.addCartItemLoading !== this.props.addCartItemLoading && prevProps.addCartItemLoading && !this.props.addCartItemLoading) {
            if (this.props.addCartItemSuccess) {
                this.props.addNotification({ message: translate('notifications.condition.addCartItemSuccess', this.props.language), type: 'success' });
            } else if (this.props.addCartItemError) {
                this.props.addNotification({ message: `${translate('notifications.condition.addCartItemError', this.props.language)} ${this.props.addCartItemError}`, type: 'error' });
            }
        }
        if (prevProps.updateCartItemLoading !== this.props.updateCartItemLoading && prevProps.updateCartItemLoading && !this.props.updateCartItemLoading) {
            if (this.props.updateCartItemSuccess) {
                this.props.addNotification({ message: translate('notifications.condition.updateCartItemSuccess', this.props.language), type: 'success' });
            } else if (this.props.updateCartItemError) {
                // Don't show error notification
            }
        }
        if (prevProps.removeCartItemLoading !== this.props.removeCartItemLoading && prevProps.removeCartItemLoading && !this.props.removeCartItemLoading) {
            if (this.props.reemoveCartItemSuccess) {
                this.props.addNotification({ message: translate('notifications.condition.reemoveCartItemSuccess', this.props.language), type: 'success' });
            } else if (this.props.removeCartItemError) {
                this.props.addNotification({ message: `${translate('notifications.condition.removeCartItemError', this.props.language)} ${this.props.removeCartItemError}`, type: 'error' });
            }
        }
        if (prevProps.clearCartItemsLoading !== this.props.clearCartItemsLoading && prevProps.clearCartItemsLoading && !this.props.clearCartItemsLoading) {
            if (this.props.clearCartItemsSuccess) {
                this.props.addNotification({ message: translate('notifications.condition.clearCartItemsSuccess', this.props.language), type: 'success' });
            } else if (this.props.clearCartItemsError) {
                this.props.addNotification({ message: `${translate('notifications.condition.clearCartItemsError', this.props.language)} ${this.props.clearCartItemsError}`, type: 'error' });
            }
        }
        if (prevProps.deleteDirectDebitLoading !== this.props.deleteDirectDebitLoading && prevProps.deleteDirectDebitLoading && !this.props.deleteDirectDebitLoading) {
            if (this.props.deleteDirectDebitSuccess) {
                this.props.addNotification({ message: translate('notifications.condition.deleteDirectDebitSuccess', this.props.language), type: 'success' });
            } else if (this.props.deleteDirectDebitError) {
                this.props.addNotification({ message: `${translate('notifications.condition.deleteDirectDebitError', this.props.language)} ${this.props.deleteDirectDebitError}`, type: 'error' });
            }
        }

        // DETAILS PROPS
        if (prevProps.userDetailsLoading !== this.props.userDetailsLoading && prevProps.userDetailsLoading && !this.props.userDetailsLoading) {
            if (this.props.userDetailsData) {
                this.props.addNotification({ message: `${translate('notifications.details.loginSuccess', this.props.language)}, ${this.props.userDetailsData.name}`, type: 'success' });
            } else if (this.props.userDetailsError) {
                // Don't show error notification
            }
        }
        if (prevProps.cartLoading !== this.props.cartLoading && prevProps.cartLoading && !this.props.cartLoading) {
            if (this.props.cartData) {
                // Don't show success notification
            } else if (this.props.cartError) {
                this.props.addNotification({ message: `${translate('notifications.details.cartError', this.props.language)} ${this.props.cartError}`, type: 'error' });
            }
        }
        if (prevProps.cartPricingLoading !== this.props.cartPricingLoading && prevProps.cartPricingLoading && !this.props.cartPricingLoading) {
            if (this.props.cartPricingData) {
                // Don't show success notification
            } else if (this.props.cartPricingError) {
                this.props.addNotification({ message: `${translate('notifications.details.cartPricingError', this.props.language)} ${this.props.cartPricingError}`, type: 'error' });
            }
        }
        if (prevProps.addCartVoucherLoading !== this.props.addCartVoucherLoading && prevProps.addCartVoucherLoading && !this.props.addCartVoucherLoading) {
            if (this.props.addCartVoucherData) {
                this.props.addNotification({ message: `${this.props.addCartVoucherData.description} ${translate('notifications.details.addCartVoucherSuccess', this.props.language)}`, type: 'success' });
            } else if (this.props.addCartVoucherError) {
                // Don't show error notification
            }
        }
        if (prevProps.cartCheckoutLoading !== this.props.cartCheckoutLoading && prevProps.cartCheckoutLoading && !this.props.cartCheckoutLoading) {
            if (this.props.cartCheckoutData) {
                // Don't show success notification
            } else if (this.props.cartCheckoutError) {
                this.props.addNotification({ message: `${translate('notifications.details.cartCheckoutError', this.props.language)} ${this.props.cartCheckoutError}`, type: 'error' });
            }
        }
        if (prevProps.itemLoading !== this.props.itemLoading && prevProps.itemLoading && !this.props.itemLoading) {
            if (this.props.itemData) {
                // Don't show success notification
            } else if (this.props.itemError) {
                this.props.addNotification({ message: `${translate('notifications.details.itemError', this.props.language)} ${this.props.itemError}`, type: 'error' });
            }
        }
        if (prevProps.priceDetailsLoading !== this.props.priceDetailsLoading && prevProps.priceDetailsLoading && !this.props.priceDetailsLoading) {
            if (this.props.priceDetailsData) {
                // Don't show success notification
            } else if (this.props.priceDetailsError) {
                this.props.addNotification({ message: `${translate('notifications.details.priceDetailsError', this.props.language)} ${this.props.priceDetailsError}`, type: 'error' });
            }
        }
        if (prevProps.searchLocationLoading !== this.props.searchLocationLoading && prevProps.searchLocationLoading && !this.props.searchLocationLoading) {
            if (this.props.searchLocationData) {
                // Don't show success notification
            } else if (this.props.searchLocationError) {
                this.props.addNotification({ message: `${translate('notifications.details.searchLocationError', this.props.language)} ${this.props.searchLocationError}`, type: 'error' });
            }
        }
        if (prevProps.reservationDetailsLoading !== this.props.reservationDetailsLoading && prevProps.reservationDetailsLoading && !this.props.reservationDetailsLoading) {
            if (this.props.reservationDetailsData) {
                // Don't show success notification
            } else if (this.props.reservationDetailsError) {
                this.props.addNotification({ message: `${translate('notifications.details.reservationDetailsError', this.props.language)} ${this.props.reservationDetailsError}`, type: 'error' });
            }
        }
        if (prevProps.cancelReservationLoading !== this.props.cancelReservationLoading && prevProps.cancelReservationLoading && !this.props.cancelReservationLoading) {
            if (this.props.cancelReservationData) {
                this.props.addNotification({ message: translate('notifications.details.cancelReservationSuccess', this.props.language), type: 'success' });
            } else if (this.props.cancelReservationError) {
                this.props.addNotification({ message: `${translate('notifications.details.cancelReservationError', this.props.language)} ${this.props.cancelReservationError}`, type: 'error' });
            }
        }
        if (prevProps.orderDetailsLoading !== this.props.orderDetailsLoading && prevProps.orderDetailsLoading && !this.props.orderDetailsLoading) {
            if (this.props.orderDetailsData) {
                // Don't show success notification
            } else if (this.props.orderDetailsError) {
                this.props.addNotification({ message: `${translate('notifications.details.orderDetailsError', this.props.language)} ${this.props.orderDetailsError}`, type: 'error' });
            }
        }
        if (prevProps.addDirectDebitLoading !== this.props.addDirectDebitLoading && prevProps.addDirectDebitLoading && !this.props.addDirectDebitLoading) {
            if (this.props.addDirectDebitData) {
                // Don't show success notification
            } else if (this.props.addDirectDebitError) {
                this.props.addNotification({ message: `${translate('notifications.details.addDirectDebitError', this.props.language)} ${this.props.addDirectDebitError}`, type: 'error' });
            }
        }
        if (prevProps.updateDirectDebitLoading !== this.props.updateDirectDebitLoading && prevProps.updateDirectDebitLoading && !this.props.updateDirectDebitLoading) {
            if (this.props.updateDirectDebitData) {
                this.props.addNotification({ message: translate('notifications.details.updateDirectDebitSuccess', this.props.language), type: 'success' });
            } else if (this.props.updateDirectDebitError) {
                this.props.addNotification({ message: `${translate('notifications.details.updateDirectDebitError', this.props.language)} ${this.props.updateDirectDebitError}`, type: 'error' });
            }
        }

        // LIST PROPS
        if (prevProps.mainTypesLoading !== this.props.mainTypesLoading && prevProps.mainTypesLoading && !this.props.mainTypesLoading) {
            if (this.props.mainTypesData) {
                // Don't show success notification
            } else if (this.props.mainTypesError) {
                this.props.addNotification({ message: `${translate('notifications.list.mainTypesError', this.props.language)} ${this.props.mainTypesError}`, type: 'error' });
            }
        }
        if (prevProps.itemTypesLoading !== this.props.itemTypesLoading && prevProps.itemTypesLoading && !this.props.itemTypesLoading) {
            if (this.props.itemTypesData) {
                // Don't show success notification
            } else if (this.props.itemTypesError) {
                this.props.addNotification({ message: `${translate('notifications.list.itemTypesError', this.props.language)} ${this.props.itemTypesError}`, type: 'error' });
            }
        }
        if (prevProps.itemTypesLoading !== this.props.itemTypesLoading && prevProps.itemTypesLoading && !this.props.itemTypesLoading) {
            if (this.props.itemsData) {
                // Don't show success notification
            } else if (this.props.itemsError) {
                this.props.addNotification({ message: `${translate('notifications.list.itemsError', this.props.language)} ${this.props.itemsError}`, type: 'error' });
            }
        }
        if (prevProps.nearbyItemsLoading !== this.props.nearbyItemsLoading && prevProps.nearbyItemsLoading && !this.props.nearbyItemsLoading) {
            if (this.props.nearbyItemsData) {
                // Don't show success notification
            } else if (this.props.nearbyItemsError) {
                this.props.addNotification({ message: `${translate('notifications.list.nearbyItemsError', this.props.language)} ${this.props.nearbyItemsError}`, type: 'error' });
            }
        }
        if (prevProps.popularLocationsLoading !== this.props.popularLocationsLoading && prevProps.popularLocationsLoading && !this.props.popularLocationsLoading) {
            if (this.props.popularLocationsData) {
                // Don't show success notification
            } else if (this.props.popularLocationsError) {
                this.props.addNotification({ message: `${translate('notifications.list.popularLocationsError', this.props.language)} ${this.props.popularLocationsError}`, type: 'error' });
            }
        }
        if (prevProps.searchAutocompleteLoading !== this.props.searchAutocompleteLoading && prevProps.searchAutocompleteLoading && !this.props.searchAutocompleteLoading) {
            if (this.props.searchAutocompleteData) {
                // Don't show success notification
            } else if (this.props.searchAutocompleteError) {
                this.props.addNotification({ message: `${translate('notifications.list.searchAutocompleteError', this.props.language)} ${this.props.searchAutocompleteError}`, type: 'error' });
            }
        }
        if (prevProps.addressesLoading !== this.props.addressesLoading && prevProps.addressesLoading && !this.props.addressesLoading) {
            if (this.props.addressesData) {
                // Don't show success notification
            } else if (this.props.addressesError) {
                this.props.addNotification({ message: `${translate('notifications.list.addressesError', this.props.language)} ${this.props.addressesError}`, type: 'error' });
            }
        }
        if (prevProps.countriesLoading !== this.props.countriesLoading && prevProps.countriesLoading && !this.props.countriesLoading) {
            if (this.props.countriesData) {
                // Don't show success notification
            } else if (this.props.countriesError) {
                this.props.addNotification({ message: `${translate('notifications.list.countriesError', this.props.language)} ${this.props.countriesError}`, type: 'error' });
            }
        }
        if (prevProps.reservationsLoading !== this.props.reservationsLoading && prevProps.reservationsLoading && !this.props.reservationsLoading) {
            if (this.props.reservationsData) {
                // Don't show success notification
            } else if (this.props.reservationsError) {
                this.props.addNotification({ message: `${translate('notifications.list.reservationsError', this.props.language)} ${this.props.reservationsError}`, type: 'error' });
            }
        }
        if (prevProps.ordersLoading !== this.props.ordersLoading && prevProps.ordersLoading && !this.props.ordersLoading) {
            if (this.props.ordersData) {
                // Don't show success notification
            } else if (this.props.ordersError) {
                this.props.addNotification({ message: `${translate('notifications.list.ordersError', this.props.language)} ${this.props.ordersError}`, type: 'error' });
            }
        }
        if (prevProps.orderReservationsLoading !== this.props.orderReservationsLoading && prevProps.orderReservationsLoading && !this.props.orderReservationsLoading) {
            if (this.props.orderReservationsData) {
                // Don't show success notification
            } else if (this.props.orderReservationsError) {
                this.props.addNotification({ message: `${translate('notifications.list.orderReservationsError', this.props.language)} ${this.props.orderReservationsError}`, type: 'error' });
            }
        }
        if (prevProps.paymentAccountsLoading !== this.props.paymentAccountsLoading && prevProps.paymentAccountsLoading && !this.props.paymentAccountsLoading) {
            if (this.props.paymentAccountsData) {
                // Don't show success notification
            } else if (this.props.paymentAccountsError) {
                this.props.addNotification({ message: `${translate('notifications.list.paymentAccountsError', this.props.language)} ${this.props.paymentAccountsError}`, type: 'error' });
            }
        }
        if (prevProps.paymentMethodsLoading !== this.props.paymentMethodsLoading && prevProps.paymentMethodsLoading && !this.props.paymentMethodsLoading) {
            if (this.props.paymentMethodsData) {
                // Don't show success notification
            } else if (this.props.paymentMethodsError) {
                this.props.addNotification({ message: `${translate('notifications.list.paymentMethodsError', this.props.language)} ${this.props.paymentMethodsError}`, type: 'error' });
            }
        }
        if (prevProps.paymentOptionsLoading !== this.props.paymentOptionsLoading && prevProps.paymentOptionsLoading && !this.props.paymentOptionsLoading) {
            if (this.props.paymentOptionsData) {
                // Don't show success notification
            } else if (this.props.paymentOptionsError) {
                this.props.addNotification({ message: `${translate('notifications.list.paymentOptionsError', this.props.language)} ${this.props.cartError}`, type: 'error' });
            }
        }
        if (prevProps.directDebitsLoading !== this.props.directDebitsLoading && prevProps.directDebitsLoading && !this.props.directDebitsLoading) {
            if (this.props.directDebitsData) {
                // Don't show success notification
            } else if (this.props.directDebitsError) {
                this.props.addNotification({ message: `${translate('notifications.list.directDebitsError', this.props.language)} ${this.props.directDebitsError}`, type: 'error' });
            }
        }
    }

    /* * * * * * * * * *
     * CUSTOM METHODS  *
     * * * * * * * * * */
    setTimeouts = () => {
        const newTimeouts = {};
        for (let id in this.state.timeouts) {
            if (this.props.notificationsData.find((notification) => notification.id === id)) {
                newTimeouts[id] = this.state.timeouts[id];
            } else {
                window.clearTimeout(this.state.timeouts[id]);
            }
        }
        this.props.notificationsData.forEach((notification) => {
            if (!newTimeouts[notification.id] && notification.timeout > 0) {
                newTimeouts[notification.id] = window.setTimeout(this.handleTimeout, notification.timeout * 1000, notification.id);
            }
        });
        this.setState({ timeouts: newTimeouts });
    }

    closeNotification = (notification) => {
        while (!notification.classList.contains(styles('notification'))) {
            notification = notification.parentNode;
        }
        if (notification) {
            notification.addEventListener('transitionend', () => this.props.onRemoveNotification(notification.getAttribute('data-notification-id')));

            notification.classList.add(styles('notification--closed'));
        }
    }

    /* * * * * * * * * *
     * EVENT HANDLERS  *
     * * * * * * * * * */
    handleClick = (event) => this.closeNotification(event.target);
    handleTimeout = (id) => this.closeNotification(document.querySelector(`[data-notification-id="${id}"]`));

    /* * * * * *
     * RENDER  *
     * * * * * */
    render() {
        const notifications = this.props.notificationsData.map((item, index) => (
            <div key={item.id}
                data-notification-id={item.id}
                className={styles('notification', 'flex', 'flex--align-center', `notification--${(item.type || 'general')}`)}
                onClick={this.handleClick}
            >
                <Icon icon={item.type === 'success' ? 'notification-tick' : item.type === 'error' ? 'notification-error' : false} modifiers={['large']} classes={styles('notification__icon')} />
                <p className={styles('notification__content')}>
                    {item.message.split(/[\n\r]/).map((line, index) => <Fragment key={index}>{line}<br /></Fragment>)}
                </p>
            </div>
        )).reverse();

        return notifications.length ? <div className={styles('notifications', 'flex', 'flex--column', 'c--text-white', 'line-height--small')}>{notifications}</div> : null;
    }
}

Notifications.propTypes = {
    // properties
    notificationsData: PropTypes.arrayOf(PropTypes.object).isRequired,

    // CONDITION PROPS
    verificationSuccess: PropTypes.bool,
    verificationLoading: PropTypes.bool,
    verificationError: PropTypes.string,
    confirmEmailSuccess: PropTypes.bool,
    confirmEmailLoading: PropTypes.bool,
    confirmEmailError: PropTypes.string,
    userDetailsData: PropTypes.object,
    userDetailsLoading: PropTypes.bool,
    userDetailsError: PropTypes.string,
    userLogoutSuccess: PropTypes.bool,
    userLogoutLoading: PropTypes.bool,
    userLogoutError: PropTypes.string,
    userPreferenceSuccess: PropTypes.bool,
    userPreferenceLoading: PropTypes.bool,
    userPreferenceError: PropTypes.string,
    userUpdateSuccess: PropTypes.bool,
    userUpdateLoading: PropTypes.bool,
    userUpdateError: PropTypes.string,
    passwordChangeSuccess: PropTypes.bool,
    passwordChangeLoading: PropTypes.bool,
    passwordChangeError: PropTypes.string,
    deleteDirectDebitSuccess: PropTypes.bool,
    deleteDirectDebitLoading: PropTypes.bool,
    deleteDirectDebitError: PropTypes.string,

    // CART PROPS
    cartData: PropTypes.object,
    cartLoading: PropTypes.bool,
    cartError: PropTypes.string,
    cartPricingData: PropTypes.object,
    cartPricingLoading: PropTypes.bool,
    cartPricingError: PropTypes.string,
    cartCheckoutData: PropTypes.object,
    cartCheckoutLoading: PropTypes.bool,
    cartCheckoutError: PropTypes.string,
    // cart items change
    addCartVoucherData: PropTypes.object,
    addCartVoucherLoading: PropTypes.bool,
    addCartVoucherError: PropTypes.string,
    removeCartVoucherSuccess: PropTypes.bool,
    removeCartVoucherLoading: PropTypes.bool,
    removeCartVoucherError: PropTypes.string,
    addCartItemSuccess: PropTypes.bool,
    addCartItemLoading: PropTypes.bool,
    addCartItemError: PropTypes.string,
    updateCartItemSuccess: PropTypes.bool,
    updateCartItemLoading: PropTypes.bool,
    updateCartItemError: PropTypes.string,
    reemoveCartItemSuccess: PropTypes.bool,
    removeCartItemLoading: PropTypes.bool,
    removeCartItemError: PropTypes.string,
    clearCartItemsSuccess: PropTypes.bool,
    clearCartItemsLoading: PropTypes.bool,
    clearCartItemsError: PropTypes.string,

    // DETAILS PROPS
    itemData: PropTypes.object,
    itemLoading: PropTypes.bool,
    itemError: PropTypes.string,
    priceDetailsData: PropTypes.object,
    priceDetailsLoading: PropTypes.bool,
    priceDetailsError: PropTypes.string,
    contactDetailsData: PropTypes.object,
    contactDetailsLoading: PropTypes.bool,
    contactDetailsError: PropTypes.string,
    searchLocationData: PropTypes.object,
    searchLocationLoading: PropTypes.bool,
    searchLocationError: PropTypes.string,
    reservationDetailsData: PropTypes.object,
    reservationDetailsLoading: PropTypes.bool,
    reservationDetailsError: PropTypes.string,
    cancelReservationData: PropTypes.object,
    cancelReservationLoading: PropTypes.bool,
    cancelReservationError: PropTypes.string,
    orderDetailsData: PropTypes.object,
    orderDetailsLoading: PropTypes.bool,
    orderDetailsError: PropTypes.string,
    paymentAccountDetailsData: PropTypes.object,
    paymentAccountDetailsLoading: PropTypes.bool,
    paymentAccountDetailsError: PropTypes.string,
    addDirectDebitData: PropTypes.object,
    addDirectDebitLoading: PropTypes.bool,
    addDirectDebitError: PropTypes.string,
    updateDirectDebitData: PropTypes.object,
    updateDirectDebitLoading: PropTypes.bool,
    updateDirectDebitError: PropTypes.string,

    // LIST PROPS
    mainTypesData: PropTypes.arrayOf(PropTypes.object),
    mainTypesLoading: PropTypes.bool,
    mainTypesError: PropTypes.string,
    itemTypesData: PropTypes.arrayOf(PropTypes.object),
    itemTypesLoading: PropTypes.bool,
    itemTypesError: PropTypes.string,
    itemsData: PropTypes.arrayOf(PropTypes.object),
    itemsLoading: PropTypes.bool,
    itemsError: PropTypes.string,
    nearbyItemsData: PropTypes.arrayOf(PropTypes.object),
    nearbyItemsLoading: PropTypes.bool,
    nearbyItemsError: PropTypes.string,
    popularLocationsData: PropTypes.arrayOf(PropTypes.object),
    popularLocationsLoading: PropTypes.bool,
    popularLocationsError: PropTypes.string,
    searchAutocompleteData: PropTypes.arrayOf(PropTypes.object),
    searchAutocompleteLoading: PropTypes.bool,
    searchAutocompleteError: PropTypes.string,
    addressesData: PropTypes.arrayOf(PropTypes.object),
    addressesLoading: PropTypes.bool,
    addressesError: PropTypes.string,
    countriesData: PropTypes.arrayOf(PropTypes.object),
    countriesLoading: PropTypes.bool,
    countriesError: PropTypes.string,
    reservationsData: PropTypes.arrayOf(PropTypes.object),
    reservationsLoading: PropTypes.bool,
    reservationsError: PropTypes.string,
    ordersData: PropTypes.arrayOf(PropTypes.object),
    ordersLoading: PropTypes.bool,
    ordersError: PropTypes.string,
    orderReservationsData: PropTypes.arrayOf(PropTypes.object),
    orderReservationsLoading: PropTypes.bool,
    orderReservationsError: PropTypes.string,
    paymentAccountsData: PropTypes.arrayOf(PropTypes.object),
    paymentAccountsLoading: PropTypes.bool,
    paymentAccountsError: PropTypes.string,
    paymentMethodsData: PropTypes.arrayOf(PropTypes.object),
    paymentMethodsLoading: PropTypes.bool,
    paymentMethodsError: PropTypes.string,
    paymentOptionsData: PropTypes.arrayOf(PropTypes.object),
    paymentOptionsLoading: PropTypes.bool,
    paymentOptionsError: PropTypes.string,
    directDebitsData: PropTypes.arrayOf(PropTypes.object),
    directDebitsLoading: PropTypes.bool,
    directDebitsError: PropTypes.string,

    language: PropTypes.string.isRequired,

    // functions
    onRemoveNotification: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        notificationsData: state.global.notifications,
        // CONDITION PROPS
        verificationSuccess: state.condition.verification.success,
        verificationLoading: state.condition.verification.loading,
        verificationError: state.condition.verification.error,
        confirmEmailSuccess: state.condition.confirmEmail.success,
        confirmEmailLoading: state.condition.confirmEmail.loading,
        confirmEmailError: state.condition.confirmEmail.error,
        userLogoutSuccess: state.condition.logout.success,
        userLogoutLoading: state.condition.logout.loading,
        userLogoutError: state.condition.logout.error,
        userPreferenceSuccess: state.condition.userPreference.success,
        userPreferenceLoading: state.condition.userPreference.loading,
        userPreferenceError: state.condition.userPreference.error,
        userUpdateSuccess: state.condition.userUpdate.success,
        userUpdateLoading: state.condition.userUpdate.loading,
        userUpdateError: state.condition.userUpdate.error,
        passwordChangeSuccess: state.condition.password.success,
        passwordChangeLoading: state.condition.password.loading,
        passwordChangeError: state.condition.password.error,
        removeCartVoucherSuccess: state.condition.removeVoucher.success,
        removeCartVoucherLoading: state.condition.removeVoucher.loading,
        removeCartVoucherError: state.condition.removeVoucher.error,
        addCartItemSuccess: state.condition.addCartItem.success,
        addCartItemLoading: state.condition.addCartItem.loading,
        addCartItemError: state.condition.addCartItem.error,
        updateCartItemSuccess: state.condition.updateCartItem.success,
        updateCartItemLoading: state.condition.updateCartItem.loading,
        updateCartItemError: state.condition.updateCartItem.error,
        reemoveCartItemSuccess: state.condition.removeCartItem.success,
        removeCartItemLoading: state.condition.removeCartItem.loading,
        removeCartItemError: state.condition.removeCartItem.error,
        clearCartItemsSuccess: state.condition.clearCart.success,
        clearCartItemsLoading: state.condition.clearCart.loading,
        clearCartItemsError: state.condition.clearCart.error,
        deleteDirectDebitSuccess: state.condition.deleteDirectDebit.success,
        deleteDirectDebitLoading: state.condition.deleteDirectDebit.loading,
        deleteDirectDebitError: state.condition.deleteDirectDebit.error,

        // DETAILS PROPS
        userDetailsData: state.details.user.data,
        userDetailsLoading: state.details.user.loading,
        userDetailsError: state.details.user.error,
        cartData: state.details.cart.data,
        cartLoading: state.details.cart.loading,
        cartError: state.details.cart.error,
        cartPricingData: state.details.cartPricing.data,
        cartPricingLoading: state.details.cartPricing.loading,
        cartPricingError: state.details.cartPricing.error,
        cartCheckoutData: state.details.checkout.data,
        cartCheckoutLoading: state.details.checkout.loading,
        cartCheckoutError: state.details.checkout.error,
        addCartVoucherData: state.details.addVoucher.data,
        addCartVoucherLoading: state.details.addVoucher.loading,
        addCartVoucherError: state.details.addVoucher.error,
        itemData: state.details.item.data,
        itemLoading: state.details.item.loading,
        itemError: state.details.item.error,
        priceDetailsData: state.details.price.data,
        priceDetailsLoading: state.details.price.loading,
        priceDetailsError: state.details.price.error,
        contactDetailsData: state.details.contact.data,
        contactDetailsLoading: state.details.contact.loading,
        contactDetailsError: state.details.contact.error,
        searchLocationData: state.details.searchLocation.data,
        searchLocationLoading: state.details.searchLocation.loading,
        searchLocationError: state.details.searchLocation.error,
        reservationDetailsData: state.details.reservation.data,
        reservationDetailsLoading: state.details.reservation.loading,
        reservationDetailsError: state.details.reservation.error,
        cancelReservationData: state.details.cancelReservation.data,
        cancelReservationLoading: state.details.cancelReservation.loading,
        cancelReservationError: state.details.cancelReservation.error,
        orderDetailsData: state.details.order.data,
        orderDetailsLoading: state.details.order.loading,
        orderDetailsError: state.details.order.error,
        paymentAccountDetailsData: state.details.paymentAccount.data,
        paymentAccountDetailsLoading: state.details.paymentAccount.loading,
        paymentAccountDetailsError: state.details.paymentAccount.error,
        addDirectDebitData: state.details.addDirectDebit.data,
        addDirectDebitLoading: state.details.addDirectDebit.loading,
        addDirectDebitError: state.details.addDirectDebit.error,
        updateDirectDebitData: state.details.updateDirectDebit.data,
        updateDirectDebitLoading: state.details.updateDirectDebit.loading,
        updateDirectDebitError: state.details.updateDirectDebit.error,

        // LIST PROPS
        mainTypesData: state.list.mainTypes.data,
        mainTypesLoading: state.list.mainTypes.loading,
        mainTypesError: state.list.mainTypes.error,
        itemTypesData: state.list.itemTypes.data,
        itemTypesLoading: state.list.itemTypes.loading,
        itemTypesError: state.list.itemTypes.error,
        itemsData: state.list.items.data,
        itemsLoading: state.list.items.loading,
        itemsError: state.list.items.error,
        nearbyItemsData: state.list.nearbyItems.data,
        nearbyItemsLoading: state.list.nearbyItems.loading,
        nearbyItemsError: state.list.nearbyItems.error,
        popularLocationsData: state.list.popularLocations.data,
        popularLocationsLoading: state.list.popularLocations.loading,
        popularLocationsError: state.list.popularLocations.error,
        searchAutocompleteData: state.list.searchAutocomplete.data,
        searchAutocompleteLoading: state.list.searchAutocomplete.loading,
        searchAutocompleteError: state.list.searchAutocomplete.error,
        addressesData: state.list.addresses.data,
        addressesLoading: state.list.addresses.loading,
        addressesError: state.list.addresses.error,
        countriesData: state.list.countries.data,
        countriesLoading: state.list.countries.loading,
        countriesError: state.list.countries.error,
        reservationsData: state.list.reservations.data,
        reservationsLoading: state.list.reservations.loading,
        reservationsError: state.list.reservations.error,
        ordersData: state.list.orders.data,
        ordersLoading: state.list.orders.loading,
        ordersError: state.list.orders.error,
        orderReservationsData: state.list.orderReservations.data,
        orderReservationsLoading: state.list.orderReservations.loading,
        orderReservationsError: state.list.orderReservations.error,
        paymentAccountsData: state.list.paymentAccounts.data,
        paymentAccountsLoading: state.list.paymentAccounts.loading,
        paymentAccountsError: state.list.paymentAccounts.error,
        paymentMethodsData: state.list.paymentMethods.data,
        paymentMethodsLoading: state.list.paymentMethods.loading,
        paymentMethodsError: state.list.paymentMethods.error,
        paymentOptionsData: state.list.paymentOptions.data,
        paymentOptionsLoading: state.list.paymentOptions.loading,
        paymentOptionsError: state.list.paymentOptions.error,
        directDebitsData: state.list.directDebits.data,
        directDebitsLoading: state.list.directDebits.loading,
        directDebitsError: state.list.directDebits.error,

        language: state.global.localization.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onRemoveNotification: (id) => dispatch(actions.removeNotification(id)),
        addNotification: (data) => dispatch(actions.addNotification(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/components/UI/Notifications/Notifications.js